import { render, staticRenderFns } from "./EditWidget.vue?vue&type=template&id=6e917d90&scoped=true"
import script from "./EditWidget.vue?vue&type=script&lang=js"
export * from "./EditWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e917d90",
  null
  
)

export default component.exports